import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconCircleAccountGrey = createIcon({
  viewBox: '0 0 41 40',
  path: (
    <>
      <mask width="41" height="40" />
      <rect
        x="0.5"
        width="40"
        height="40"
        rx="20"
        fill="black"
        fillOpacity="0.05"
      />
      <path
        d="M20.4993 19.9998C22.5252 19.9998 24.166 18.359 24.166 16.3332C24.166 14.3073 22.5252 12.6665 20.4993 12.6665C18.4735 12.6665 16.8327 14.3073 16.8327 16.3332C16.8327 18.359 18.4735 19.9998 20.4993 19.9998ZM20.4993 21.8332C18.0518 21.8332 13.166 23.0615 13.166 25.4998V27.3332H27.8327V25.4998C27.8327 23.0615 22.9468 21.8332 20.4993 21.8332Z"
        fill="black"
        fillOpacity="0.16"
      />
    </>
  ),
});

export default IconCircleAccountGrey;
